export default function getNodePath(nodePath) {
  return nodePath.join('.');
}